import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

interface BloodPressureInputProps {
  form: UseFormReturn<any>;
  systolicName: string;
  diastolicName: string;
  label?: string;
  required?: boolean;
  className?: string;
}

const BloodPressureInput: React.FC<BloodPressureInputProps> = ({
  form,
  systolicName,
  diastolicName,
  label = 'Blood Pressure',
  required = false,
  className,
}) => {
  const systolicError = form.formState.errors[systolicName];
  const diastolicError = form.formState.errors[diastolicName];

  return (
    <div className={cn('space-y-2', className)}>
      {label && (
        <Label className={required ? 'required' : ''}>
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </Label>
      )}

      <div className="flex items-center gap-2">
        <Input
          type="number"
          value={form.watch(systolicName) ?? ''}
          onChange={(e) => {
            const val = e.target.value;
            form.setValue(systolicName, val === '' ? '' : parseInt(val, 10), {
              shouldValidate: true,
            });
          }}
          placeholder="Systolic"
          className="flex-1"
          min={0}
          max={300}
        />
        <span className="text-lg font-bold text-slate-400">/</span>
        <Input
          type="number"
          value={form.watch(diastolicName) ?? ''}
          onChange={(e) => {
            const val = e.target.value;
            form.setValue(diastolicName, val === '' ? '' : parseInt(val, 10), {
              shouldValidate: true,
            });
          }}
          placeholder="Diastolic"
          className="flex-1"
          min={0}
          max={300}
        />
        <span className="text-sm font-bold text-slate-500">mmHg</span>
      </div>

      {systolicError && (
        <p className="text-[0.8rem] text-red-500">
          {systolicError.message as string}
        </p>
      )}
      {diastolicError && (
        <p className="text-[0.8rem] text-red-500">
          {diastolicError.message as string}
        </p>
      )}
    </div>
  );
};

export default BloodPressureInput;
